import React from "react";

type ComponentTypeWithProps<P = unknown> =
  | React.ComponentType<P>
  | React.NamedExoticComponent<P>;

type Factory<P> = () => Promise<{
  default: ComponentTypeWithProps<P>;
}>;

export type LazyWithPreload<P> = React.LazyExoticComponent<
  ComponentTypeWithProps<P>
> & {
  preload: () => Promise<void>;
};

export function lazyImport<P = unknown>(
  factory: Factory<P>,
  options?: { memo?: boolean },
): LazyWithPreload<P> {
  const lazyComp = React.lazy(factory);
  const component = (
    options?.memo ? React.memo(lazyComp) : lazyComp
  ) as LazyWithPreload<P>;
  component.preload = () => factory().then(() => {});
  return component;
}
